import { createSelector } from '@reduxjs/toolkit';
import { selectEarlyAccess, selectJsonQuery } from 'shared/selectors/jsonQuery';
import { IConfig } from '@cian/config/shared';
import { NBSP } from 'shared/constants/symbols';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';
import { checkEarlyAccessAvailability } from 'shared/utils/earlyAccess';

export const selectEarlyAccessFilter = (config: IConfig) => {
  return createSelector(
    [selectEarlyAccess, selectJsonQuery, selectIsInlineFiltersRedesigned, selectPageType],
    (value, jsonQuery, isFiltersRedesign, pageType) => ({
      label: 'Ранний доступ',
      description: `Объявления от${NBSP}собственников, которые недавно\nопубликовали. Просмотр контактов — платный.`,
      value: Boolean(value),
      visible:
        !(isFiltersRedesign && pageType === EPageType.MAIN) && checkEarlyAccessAvailability({ jsonQuery, config }),
    }),
  );
};
